module.exports = __webpack_public_path__ + "img/wechat.bbdeff80.png";